var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneNzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_radial_2646_7999)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2646_7999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2646_7999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9883 36.6098C37.6834 36.6098 45.5429 28.7503 45.5429 19.0552C45.5429 9.35998 37.6834 1.50049 27.9883 1.50049C18.2931 1.50049 10.4336 9.35998 10.4336 19.0552C10.4336 28.7503 18.2931 36.6098 27.9883 36.6098Z",
    fill: "url(#paint1_radial_2646_7999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0065 41.4586C33.6514 41.4586 41.4701 33.6399 41.4701 23.9951C41.4701 14.3502 33.6514 6.53149 24.0065 6.53149C14.3617 6.53149 6.54297 14.3502 6.54297 23.9951C6.54297 33.6399 14.3617 41.4586 24.0065 41.4586Z",
    fill: "url(#paint2_radial_2646_7999)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint3_radial_2646_7999)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint4_radial_2646_7999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2646_7999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#46F8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05B571"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2646_7999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9883 19.0552) scale(17.5547 17.5547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2FFFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2646_7999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0065 23.9951) scale(17.4636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8CFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#69FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2646_7999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2646_7999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#46F8A2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#45F6A1",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#40F29E",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#39EA99",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#30DF91",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#23D088",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#14BF7C",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05AE71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneNzLogo);
export default __webpack_public_path__ + "static/media/one-nz-logo.f95db9f8b9c9c973aa6732a371df11f1.svg";
export { ForwardRef as ReactComponent };